import { sendGetRequest } from "@/helper/requests"
import selectors from "@/urls/selectors"

const state = {
  selectors: {
    signerRecipients: [],
    accountCountry: [],
    accountCountryCode: [],
    accountLanguages: [],
    accountAccounts: [],
  }
}

const getters = {
  signerRecipients: state => state.selectors.signerRecipients,
  accountCountry: state => state.selectors.accountCountry,
  accountCountryCode: state => state.selectors.accountCountryCode,
  accountLanguages: state => state.selectors.accountLanguages,
  accountAccounts: state => state.selectors.accountAccounts,
}

const mutations = {
  SET_RECIPIENTS: (state, value) => {
    /**
     * Сохраняет список получателей для документооборота
     * @param {Object} state - состояние хранилища
     * @param {Array} value - массив получателей
     */
    state.selectors.signerRecipients = value
  },
  SET_COUNTRY: (state, value) => {
    /**
     * Устанавливает список стран
     * @param {Object} state - состояние хранилища
     * @param {Array} value - массив стран
     */
    state.selectors.accountCountry = value
  },
  SET_COUNTRY_CODE: (state, value) => {
    /**
     * Устанавливает телефонные коды стран
     * @param {Object} state - состояние хранилища
     * @param {Array} value - массив телефонных кодов
     */
    state.selectors.accountCountryCode = value
  },
  SET_LANGUAGES: (state, value) => {
    /**
     * Устанавливает список доступных языков
     * @param {Object} state - состояние хранилища
     * @param {Array} value - массив языков
     */
    state.selectors.accountLanguages = value
  },
  SET_ACCOUNTS: (state, value) => {
    /**
     * Устанавливает список связанных аккаунтов
     * @param {Object} state - состояние хранилища
     * @param {Array|null} value - массив связанных аккаунтов или null
     */
    state.selectors.accountAccounts = value
  },
}

const actions = {
  loadSignerRecipients: ({ commit }, { url, finalizer, catcher }) => {
    /**
     * Загружает список получателей для системы электронного подписания
     * @param {Object} context - контекст Vuex
     * @param {Object} params - параметры запроса
     * @param {string} params.url - URL для загрузки (опционально)
     * @param {Function} params.finalizer - функция обратного вызова при успехе
     * @param {Function} params.catcher - функция обратного вызова при ошибке
     */
    if (!url) url = selectors.SELECTORS.SIGNER.RECIPIENTS()
    sendGetRequest(
      url, (data, url) => {
        commit('SET_RECIPIENTS', data)
        finalizer(data, url)
      }, catcher
    )
  },
  loadAccountCountryCode: ({ commit }, { url, finalizer, catcher }) => {
    /**
     * Загружает телефонные коды стран
     * @param {Object} context - контекст Vuex
     * @param {Object} params - параметры запроса
     * @param {string} params.url - URL для загрузки (опционально)
     * @param {Function} params.finalizer - функция обратного вызова при успехе
     * @param {Function} params.catcher - функция обратного вызова при ошибке
     */
    if (!url) url = selectors.SELECTORS.ACCOUNTS.COUNTRY_CODE()
    sendGetRequest(
      url, (data, url) => {
        commit('SET_COUNTRY_CODE', data)
        finalizer(data, url)
      }, catcher
    )
  },
  loadAccountCountry: ({ commit }, { url, finalizer, catcher }) => {
    /**
     * Загружает список стран
     * @param {Object} context - контекст Vuex
     * @param {Object} params - параметры запроса
     * @param {string} params.url - URL для загрузки (опционально)
     * @param {Function} params.finalizer - функция обратного вызова при успехе
     * @param {Function} params.catcher - функция обратного вызова при ошибке
     */
    if (!url) url = selectors.SELECTORS.ACCOUNTS.COUNTRY()
    sendGetRequest(
      url, (data, url) => {
        commit('SET_COUNTRY', data)
        finalizer(data, url)
      }, catcher
    )
  },
  loadAccountLanguages: ({ commit }, { url, finalizer, catcher }) => {
    /**
     * Загружает список доступных языков для интерфейса
     * @param {Object} context - контекст Vuex
     * @param {Object} params - параметры запроса
     * @param {string} params.url - URL для загрузки (опционально)
     * @param {Function} params.finalizer - функция обратного вызова при успехе
     * @param {Function} params.catcher - функция обратного вызова при ошибке
     */
    if (!url) url = selectors.SELECTORS.ACCOUNTS.LANGUAGES()
    sendGetRequest(
      url, (data, url) => {
        commit('SET_LANGUAGES', data)
        finalizer(data, url)
      }, catcher
    )
  },
  loadAccountAccounts: ({ commit }, { url, finalizer, catcher }) => {
    /**
     * Загружает список связанных аккаунтов
     * @param {Object} context - контекст Vuex
     * @param {Object} params - параметры запроса
     * @param {string} params.url - URL для загрузки (опционально)
     * @param {Function} params.finalizer - функция обратного вызова при успехе
     * @param {Function} params.catcher - функция обратного вызова при ошибке
     */
    if (!url) url = selectors.SELECTORS.ACCOUNTS.ACCOUNTS()
    sendGetRequest(
      url, (data, url) => {
        commit('SET_ACCOUNTS', data)
        finalizer(data, url)
      }, catcher
    )
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
